import { analytics } from "../index";

export const onPayment = () => {
  // @ts-ignore
  analytics.logEvent('payment')
};
